module.exports = __webpack_public_path__ + "img/SCOTLAND.93a1bcf8.svg";